// extracted by mini-css-extract-plugin
export default {"menu_container":"MenuTabs_menu_container__POzNK","menu":"MenuTabs_menu__HdX7S"};